<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Agenda</v-toolbar-title>
          <v-spacer />
          <v-btn v-if="!semRodada" color="primary lighten-4">
            Imprimir
          </v-btn>
        </v-app-bar>

        <div
          class="ma-3"
          :style="loading ? 'filter: opacity(0.5); pointer-events: none' : ''"
        >
          <v-row
            v-if="!semRodada"
            dense
            style="text-align: center; pointer-events: none; padding-bottom: 8px"
          >
            <v-col cols="6">
              <v-text-field
                hide-details
                label="Rodada"
                v-model="rodada.nome"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                hide-details
                label="Cidade"
                v-model="rodada.cidade_nome"
              >
              </v-text-field>
            </v-col>

            <v-col cols="2">
              <v-text-field
                hide-details
                label="Estado"
                v-model="rodada.estado_nome"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-else dense style="pointer-events: none; padding-bottom: 8px">
            <v-col cols="12">
              <span
                >Você não participa ou participou de nenhuma rodada de negócios.
                Fale com seu representante!</span
              >
            </v-col>
          </v-row>

          <v-row
            v-if="['administrador'].includes(user.tipo)"
            style="text-align: center; padding: 0px 12px 12px"
          >
            <v-select
              :items="rodadas"
              label="Rodada"
              v-model="rodada"
              item-text="nome"
              item-value="id"
              hide-details
              return-object
              placeholder="Selecione uma rodada"
              style="width:100%"
              @change="atualizar"
            />
          </v-row>

          <v-row
            v-if="['representante', 'administrador'].includes(user.tipo)"
            style="text-align: center; padding: 0px 12px 12px"
          >
            <v-select
              :items="clientes"
              label="Cliente"
              v-model="cliente"
              item-text="nome"
              item-value="id"
              hide-details
              return-object
              placeholder="Selecione um cliente"
              style="width:100%"
              @change="atualizarCliente"
            />
          </v-row>

          <v-row
            v-if="['administrador'].includes(user.tipo)"
            style="text-align: center; padding: 0px 12px 12px"
          >
            <v-select
              :items="fornecedores"
              label="Fornecedor"
              v-model="fornecedor"
              item-text="nome_fantasia"
              item-value="id"
              hide-details
              return-object
              placeholder="Selecione um fornecedor"
              style="width:100%"
              @change="atualizarFornecedor"
            />
          </v-row>

          <v-row v-if="agenda.length > 0" dense style="text-align: center">
            <v-col cols="2">
              <v-btn
                v-if="!loading"
                large
                color="warning"
                width="100%"
                @click="atualizar"
              >
                Atualizar
              </v-btn>
            </v-col>

            <v-col
              cols="2"
              color="primary"
              v-for="(dia, i) in agenda"
              :key="i"
              style="pointer-events: none;"
            >
              <v-btn large color="primary" width="100%">{{ dia.dia }}</v-btn>
              {{
                dia.data.toISOString().substring(8, 10) +
                  "/" +
                  dia.data.toISOString().substring(5, 7) +
                  "/" +
                  dia.data.toISOString().substring(0, 4)
              }}
            </v-col>
          </v-row>

          <v-row
            v-for="(hora, i) in horarios"
            :key="hora"
            dense
            :style="
              'text-align: center;border-radius: ' +
                (i === horarios.length - 1
                  ? '0px 0px 6px 6px'
                  : i === 0
                  ? '6px 6px 0px 0px'
                  : '0px') +
                '; background-color:' +
                getCorPeriodoDia(hora)
            "
            class="mx-1"
          >
            <v-col
              cols="2"
              style="align-items: center; display: inline-grid; font-weight: 600; user-select: none;"
            >
              <span>{{ getPeriodoDia(hora) }}</span>
            </v-col>

            <v-col
              v-for="horario in agenda.map((item) => item.horarios[i])"
              :key="horario.dataHora"
              cols="2"
            >
              <v-tooltip
                left
                :color="getButtonColor(horario)"
                :disabled="horario.nome === null"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    name="horario-tag"
                    :class="
                      horario.nome
                        ? 'sala-virtual' +
                          (checkDataHora(horario.dataHora) === 2 && ' blink')
                        : ''
                    "
                    :id="horario.dataHora"
                    v-bind="attrs"
                    v-on="on"
                    :style="
                      checkDataHora(horario.dataHora) === 0
                        ? 'opacity: 0.3; filter: brightness(0.7); background-color: #f5f5f5 !important; pointer-events: none'
                        : ''
                    "
                    :color="getButtonColor(horario)"
                    @click="abrirSalaVirtual(horario)"
                    >{{ horario.horario }}</v-btn
                  >
                </template>
                <span>{{ horario.nome }}</span>
              </v-tooltip>
            </v-col>
          </v-row>

          <v-row v-if="agenda.length > 0" dense style="text-align: center">
            <div class="mr-auto mt-auto mb-3 ml-2" style="color: red">
              Horário de Brasília
            </div>

            <v-chip
              disabled
              class="mr-2 mt-3 mb-3"
              small
              chip
              label
              color="#e0e0e0"
              >Indisponível</v-chip
            >

            <v-chip class="mr-2 mt-3" small chip label color="#e0e0e0"
              >Livre</v-chip
            >

            <v-chip class="mr-2 mt-3" small chip label color="error"
              >Agendado</v-chip
            >

            <v-chip class="mr-2 mt-3" small chip label color="success"
              >Sala Virtual Aberta</v-chip
            >
          </v-row>
        </div>

        <v-row v-if="loading" dense class="pb-3 px-5">
          <v-progress-linear
            buffer-value="55"
            color="success"
            stream
            value="30"
          />
        </v-row>

        <as-dialogo ref="dialogoHorario" title="Agenda" max-width="640px">
          <v-row
            v-if="horario"
            dense
            style="text-align: center; pointer-events: none;"
          >
            <v-col cols="12">
              <v-text-field
                hide-details
                read-only
                label="Cliente"
                v-model="horario.clienteNome"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="horario"
            dense
            style="text-align: center; pointer-events: none;"
          >
            <v-col cols="12">
              <v-text-field
                hide-details
                read-only
                label="Fornecedor"
                v-model="horario.fornecedorNome"
              />
            </v-col>
          </v-row>
          <v-row
            v-if="horario"
            dense
            style="text-align: center; pointer-events: none;"
          >
            <v-col cols="12">
              <v-text-field
                hide-details
                read-only
                label="Representante"
                v-model="horario.representanteNome"
              />
            </v-col>
          </v-row>

          <v-row
            v-if="horario"
            dense
            style="text-align: center; pointer-events: none;"
          >
            <v-col cols="8">
              <v-text-field
                hide-details
                read-only
                label="Dia"
                :value="
                  diasSemana[new Date(horario.dataHora).getUTCDay()] +
                    ', ' +
                    new Date(horario.dataHora).getUTCDate() +
                    ' de ' +
                    mesesAno[
                      new Date(horario.dataHora).getUTCMonth()
                    ].toLowerCase() +
                    ' de ' +
                    new Date(horario.dataHora).getUTCFullYear()
                "
              />
            </v-col>

            <v-col cols="4">
              <v-text-field
                hide-details
                read-only
                label="Hora"
                v-model="horario.horario"
              />
            </v-col>
          </v-row>

          <v-row
            v-if="horario && user.tipo === 'cliente'"
            dense
            style="text-align: center"
          >
            <v-checkbox
              v-model="cancelarHorario"
              label="Cancelar este agendamento"
              color="red"
              value="red"
              hide-details
            />

            <v-btn
              v-if="cancelarHorario"
              class="mt-auto ml-auto mr-1 text-white"
              color="error"
              @click="cancelar"
            >
              Cancelar
            </v-btn>
          </v-row>
        </as-dialogo>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ServiceRodadas from "@/services/rodadas.js";
import ServiceAgendamentos from "@/services/agendamentos.js";

export default {
  name: "Agenda",

  data() {
    return {
      fornecedores: [],
      fornecedor: {},
      clientes: [],
      cliente: {},
      representantes: [],
      rodadas: [],
      rodada: {},
      diasSemana: [],
      mesesAno: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
      horarios: [],
      agenda: [],
      user: {},
      horario: null,
      loading: true,
      cancelarHorario: false,
      checkDataHoraTimer: null,
      userTipo: null,
      semRodada: false,
    };
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem("user") || "{}");
    this.userTipo = this.user.tipo;
    this.loading = true;
    this.atualizar();
    this.timer();
  },

  unmounted() {
    clearInterval(this.checkDataHoraTimer);
  },

  methods: {
    normalizeDateString(date) {
      if (typeof date === "object" || typeof date === "number") {
        return date;
      } else if (
        typeof date === "string" &&
        date[4] !== "-" &&
        date[2] === "/"
      ) {
        // dd/mm/yyyy
        return (
          date.substring(6, 10) +
          "-" +
          date.substring(3, 5) +
          "-" +
          date.substring(0, 2)
        );
      }
      return date;
    },

    atualizarCliente() {
      this.fornecedor = {};
      this.userTipo = "cliente";
      this.atualizar();
    },

    atualizarFornecedor() {
      this.cliente = {};
      this.userTipo = "fornecedor";
      this.atualizar();
    },

    async atualizar() {
      this.loading = true;

      if (this.user.tipo === "cliente") {
        const {
          data: dataRodadas,
        } = await ServiceRodadas.carregarRodadasCliente();
        this.rodadas = dataRodadas.rodadas || [];
        if (this.rodadas.length > 0) {
          this.rodada = dataRodadas.rodadas[dataRodadas.rodadas.length - 1];
        } else {
          this.semRodada = true;
        }
      }

      if (!this.semRodada) {
        if (this.rodadas.length === 0) {
          const { data } = await ServiceRodadas.index();
          this.rodadas = data.rodadas;
          const rodadaAtiva = JSON.parse(
            localStorage.getItem("rodada") || "{}"
          );
          if (rodadaAtiva.id) {
            this.rodada =
              data.rodadas.find((row) => row.id === rodadaAtiva.id) || {};
          } else {
            this.rodada = data.rodadas[data.rodadas.length - 1] || {};
          }
        }

        const { data: agenda } = await ServiceAgendamentos.index(
          this.rodada.id,
          {
            cliente_id: this.cliente.id,
            fornecedor_id: this.fornecedor.id,
          }
        );

        const {
          data: dataFornecedores,
        } = await ServiceRodadas.carregarFornecedoresRodada(this.rodada.id);

        const {
          data: dataClientes,
        } = await ServiceRodadas.carregarClientesRodada(this.rodada.id);

        const {
          data: dataRepresentantes,
        } = await ServiceRodadas.carregarRepresentantesRodada(this.rodada.id);

        this.fornecedores = dataFornecedores.fornecedores || [];
        this.representantes = dataRepresentantes.representantes || [];

        if (this.user.tipo === "representante") {
          this.clientes =
            (dataClientes.clientes &&
              dataClientes.clientes.filter(
                (row) => row.representante_id === this.user.representante_id
              )) ||
            [];
        } else {
          this.clientes = dataClientes.clientes || [];
        }

        this.diasSemana = [
          "Domingo",
          "Segunda",
          "Terça",
          "Quarta",
          "Quinta",
          "Sexta",
          "Sábado",
        ];

        this.horarios = [
          "00:00 - 01:30",
          "01:30 - 03:00",
          "08:00 - 09:30",
          "09:30 - 11:00",
          "11:00 - 12:30",
          "12:30 - 14:00",
          "14:00 - 15:30",
          "15:30 - 17:00",
          "17:00 - 18:30",
          "18:30 - 20:00",
          "20:00 - 21:30",
          "21:30 - 22:00",
          "22:00 - 23:30",
        ];

        const fim = new Date(this.normalizeDateString(this.rodada.data_fim));
        const dia = new Date(this.normalizeDateString(this.rodada.data_inicio));

        const mappedData = [];

        while (dia <= fim) {
          mappedData.push({
            dia: this.diasSemana[dia.getUTCDay()],
            data: new Date(dia.toISOString().substring(0, 10)),
            horarios: this.horarios.map((horario) => {
              const dataHora = new Date(
                new Date(dia.toISOString()).setUTCHours(
                  horario.substring(0, 2),
                  horario.substring(3, 5)
                )
              );
              const found = agenda.agendamentos.find(
                (item) =>
                  item.data_hora ===
                  dataHora.getUTCFullYear() +
                    "-" +
                    String(dataHora.getUTCMonth() + 1).padStart(2, "0") +
                    "-" +
                    String(dataHora.getUTCDate()).padStart(2, "0") +
                    " " +
                    String(dataHora.getUTCHours()).padStart(2, "0") +
                    ":" +
                    String(dataHora.getUTCMinutes()).padStart(2, "0") +
                    ":00"
              );
              let cliForFound = null;
              if (this.userTipo === "cliente") {
                cliForFound = found
                  ? this.fornecedores.find(
                      (forn) => forn.id === found.fornecedor_id
                    )
                  : null;
              } else {
                cliForFound = found
                  ? this.clientes.find((forn) => forn.id === found.cliente_id)
                  : null;
              }

              return {
                horario,
                dataHora: new Date(dia.toISOString()).setUTCHours(
                  horario.substring(0, 2),
                  horario.substring(3, 5)
                ),
                fornecedorId: found ? found.fornecedor_id : null,
                nome: cliForFound
                  ? cliForFound.nome_fantasia || cliForFound.nome
                  : null,
                clienteId: found ? found.cliente_id : null,
                representanteId: found ? found.representante_id : null,
                id: found ? found.id : null,
                uuid: found ? found.uuid : null,
              };
            }),
          });
          dia.setDate(dia.getDate() + 1);
        }

        this.agenda = mappedData;

        if (mappedData.length === 0) {
          this.horarios = [];
        }
      }

      this.loading = false;
    },

    getPeriodoDia(hora) {
      const horaInt = parseInt(hora.substring(0, 2));
      if (horaInt < 12) {
        return "Manhã";
      } else if (horaInt < 14) {
        return "Almoço";
      } else if (horaInt < 18) {
        return "Tarde";
      } else {
        return "Noite";
      }
    },

    getCorPeriodoDia(hora) {
      const horaInt = parseInt(hora.substring(0, 2));
      if (horaInt < 12) {
        return "lightyellow";
      } else if (horaInt < 14) {
        return "lightgrey";
      } else if (horaInt < 18) {
        return "#ffdc9b";
      } else {
        return "lightslategray";
      }
    },

    getButtonColor(horario) {
      const check = horario ? this.checkDataHora(horario.dataHora) : 0;
      if (!horario || check === 0) {
        return "";
      } else if (check === 2 && horario.nome) {
        return "success";
      } else if (this.fornecedor.id === horario.fornecedorId) {
        return "info";
      } else if (horario.fornecedorId) {
        return "error";
      }
      return "";
    },

    checkDataHora(horario) {
      const minhaData = new Date();
      // Timezone de brasília - 3
      minhaData.setHours(minhaData.getHours() - 3);
      if (new Date(horario) < minhaData) {
        if (
          minhaData <
          new Date(horario).setMinutes(new Date(horario).getMinutes() + 90)
        ) {
          // Presente
          return 2;
        }
        // Passado
        return 0;
      }

      // Futuro
      return 1;
    },

    abrirSalaVirtual(horario) {
      if (horario.nome) {
        this.horario = horario;
        this.horario.clienteNome =
          this.clientes.find((row) => row.id === this.horario.clienteId)
            ?.nome || "";
        this.horario.fornecedorNome =
          this.fornecedores.find((row) => row.id === this.horario.fornecedorId)
            ?.nome_fantasia || "";
        this.horario.representanteNome =
          this.representantes.find(
            (row) => row.id === this.horario.representanteId
          )?.nome_fantasia || "";

        if (
          ["cliente", "representante", "fornecedor"].includes(this.user.tipo)
        ) {
          const el = document.getElementById(horario.dataHora);
          if (el.classList.contains("blink")) {
            this.$store.commit("setRodadaVirtual", {
              status: true,
              data: { ...this.horario },
            });
          } else {
            this.$refs.dialogoHorario.abrir();
          }
        } else {
          this.horario = horario;
          this.$refs.dialogoHorario.abrir();
        }
      }
    },

    timer() {
      const self = this;
      this.checkDataHoraTimer = setInterval(function() {
        const elArray = document.getElementsByName("horario-tag");
        if (elArray) {
          elArray.forEach((el) => {
            if (!el.disabled) {
              const check = self.checkDataHora(parseInt(el.id));
              if (check === 0) {
                el.disabled = true;
                el.style.opacity = 0.3;
                el.style.filter = "brightness(0.7)";
                el.classList.remove("blink");
                el.classList.remove("success");
                el.classList.remove("error");
              }
              if (check === 2 && el.classList.contains("sala-virtual")) {
                el.classList.add("blink");
                el.classList.add("success");
                el.classList.remove("error");
              }
            }
          });
        }
      }, 10000);
    },

    cancelar() {
      this.cancelarHorario = false;
      this.$refs.dialogoHorario.fechar();

      ServiceAgendamentos.excluir(this.horario.id).then(() => {
        this.atualizar();
      });
    },
  },
};
</script>

<style>
.blink {
  animation: unset;
}
</style>
